/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import React, { ReactNode } from 'react'
import { Paper, Typography, Stack, PaperProps } from '@mui/material'

export interface TitledPaperProps extends Omit<PaperProps, 'title'> {
  title: ReactNode
  subtitle?: ReactNode
  action?: ReactNode
}

export const TitledPaper: React.FC<TitledPaperProps> = ({
  title,
  subtitle,
  action,
  children,
  sx,
  ...props
}) => {
  return (
    <Paper
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        width: '100%',
        ...sx,
      }}
    >
      <Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="left">
          {title && (
            <Typography component="h1" variant="h3" gutterBottom>
              {title}
            </Typography>
          )}
          {action && action}
        </Stack>
        {subtitle && (
          <Typography component="h2" variant="subtitle1">
            {subtitle}
          </Typography>
        )}
      </Stack>
      {children}
    </Paper>
  )
}
